import { TableContainer } from "@mui/material";
import Section from "pages/components/Section";
import { PaymentIn } from "Domain/PaymentPlan/Entity/PaymentPlan";
import { formatPrice, getDateFormat } from "pages/Utils/Formats";
import moment from "moment";
import PaymentInStatusChip from "pages/components/Status/PaymentInStatusChip";
import CustomTable from "pages/components/CustomTable";

type DisplayPaymentsInProps = {
  paymentsIn: Array<PaymentIn>;
};

export default function DisplayPaymentsInDetails({
  paymentsIn,
}: DisplayPaymentsInProps) {
  return (
    <Section title={"payments_in"} accordion={true} initOpen={true}>
      <TableContainer sx={{ marginTop: -3, marginBottom: -2 }}>
        <CustomTable
          data={formatPayIns(paymentsIn)}
          horizontal={false}
          config={getTableConfig()}
        />
      </TableContainer>
    </Section>
  );
}

function formatPayIns(paymentsIn: Array<PaymentIn>) {
  const tableData: Array<any> = [];

  paymentsIn.forEach((paymentIn) => {
    tableData.push({
      sequence: paymentIn.sequence,
      date: moment(paymentIn.dueDate).format(getDateFormat()),
      paymentAmount: formatPrice(paymentIn.paymentAmount),
      dueAmount: formatPrice(paymentIn.dueAmount),
      status: <PaymentInStatusChip status={paymentIn.status} />,
    });
  });

  return tableData;
}

function getTableConfig() {
  return {
    sequence: { sx: { width: "20px" } },
    status: { align: "right" },
  };
}
